import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { photos } from './Photos'
import SystemRequirementsCS from './SystemRequirementsCS.json'
import SimpleSpinner from '../../components/Common/SimpleSpinner'
import '../News/news.css'

const ReleaseNotes = React.lazy(() => import('../../components/ReleaseNotes/ReleaseNotes'))
const Content = React.lazy(() => import('./ContentCS'))
const VirtualTrainingCS = React.lazy(() => import('../Learning/VirtualTrainingCS'))
const Gallery = React.lazy(() => import('../Gallery'))
const SystemRequirements = React.lazy(() => import('../SystemRequirements'))
const Error404 = React.lazy(() => import('../Error404'))
const B9Creations = React.lazy(() => import('./B9Creations'))
const Membership = React.lazy(() => import('../Membership/Membership'))

const CounterSketchRoutes = () => {
  return (
    <React.Suspense fallback={<SimpleSpinner />}>
      <Routes>
        <Route path='/' element={<Content />} />
        <Route path='/gallery' element={<Gallery product={'CS'} jsonData={photos} />} />
        <Route path='/release-notes/:slug' element={<ReleaseNotes software='countersketch' activeSlug={true} />} />
        <Route path='/release-notes' element={<ReleaseNotes software='countersketch' />} />
        <Route path='/jewelry-3d-printing' element={<B9Creations />} />
        <Route path='/virtual-training' element={<VirtualTrainingCS />} />
        <Route path='/membership' element={<Membership product='CounterSketch' />} />
        <Route
          path='/systemrequirements'
          element={<SystemRequirements product={'CS'} jsonData={SystemRequirementsCS} />}
        />
        <Route path='*' element={<Error404 />} />
      </Routes>
    </React.Suspense>
  )
}
export default CounterSketchRoutes
